import { action, isAbortError } from '@reatom/framework'

import { Result, Option } from '@blade/std-lib'
import { UnknownError } from '@root/shared'

import { GithubUserProfile } from '../model/github-user-profile'

interface GetGithubUserProfileRequestActionParams {
  username: string
}

export const getGithubUserProfileRequestAction = action(
  async (
    ctx,
    params: GetGithubUserProfileRequestActionParams,
  ): Promise<Result.Result<GithubUserProfile, UnknownError>> => {
    try {
      const url = `https://api.github.com/users/${params.username}`

      const response = await ctx.schedule(() => fetch(url))

      if (!response.ok) {
        return Result.fail(
          UnknownError.fromUnknown(
            `Github user profile request failed: ${response.status}`,
          ),
        )
      }

      const json = (await ctx.schedule(() => response.json())) as unknown

      const decoded = GithubUserProfile.decode(json)

      if (Option.isNone(decoded)) {
        return Result.fail(
          UnknownError.fromUnknown('Failed to decode github user profile'),
        )
      }

      return Result.succeed(decoded.value)
    } catch (error) {
      if (isAbortError(error)) {
        throw error
      }
      return Result.fail(UnknownError.fromUnknown(error))
    }
  },
  'getGithubUserProfileRequestAction',
)
